import { Link } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Tooltip } from "@mui/material";
import { useGo, useTranslate, useUpdate } from "@refinedev/core";
import type { DeleteButtonProps } from "@refinedev/mui";
import React from "react";

export const ToRoomButton: React.FC<DeleteButtonProps> = ({
  resource: resourceNameFromProps,
  recordItemId,
  onSuccess,
  mutationMode: mutationModeProp,
  children,
  successNotification,
  errorNotification,
  hideText = false,
  accessControl,
  meta,
  dataProviderName,
  confirmTitle,
  confirmOkText,
  confirmCancelText,
  svgIconProps,
  invalidates,
  ...rest
}) => {
  const accessControlEnabled = accessControl?.enabled ?? true;
  const hideIfUnauthorized = accessControl?.hideIfUnauthorized ?? false;
  const translate = useTranslate();
  const go = useGo(); 
    const { isLoading } = useUpdate();


  const handleClick = () => {
    go({
        to: `/rooms/edit/${recordItemId}`,
        type: "push",
    });
  };

  

  const { sx, ...restProps } = rest;

  if (accessControlEnabled && hideIfUnauthorized) {
    return null;
  }

  return (
    <div>
      <Tooltip title="To Room">
        <LoadingButton
          color="error"
          onClick={handleClick}
          loading={isLoading}
          startIcon={!hideText && <Link {...svgIconProps} />}
          sx={{ minWidth: 0, ...sx }}
          loadingPosition={hideText ? "center" : "start"}
          {...restProps}
        >
          {hideText ? (
            <Link fontSize="small" {...svgIconProps} color="success"/>
          ) : (
            children ?? translate("buttons.delete", "Delete")
          )}
        </LoadingButton>
      </Tooltip>
    </div>
  );
};
